import type { ReactNode } from 'react';

export function EditorShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-brut-bg text-brut-fg font-mono antialiased">
      {children}
    </div>
  );
}
